import React from 'react';

import Card from '@mui/material/Card';
import { useNavigate } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

function CustomerActionCard(props) {
  let defaultCategory = props.category;
  let defaultRegion = props.region;
  let defaultAMC = props.asset_man_comp;

  const navigate = useNavigate();

  return (
    <Card
      sx={{
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        margin: 0,
        padding: 0,
      }}
    >
      <Stack
        spacing={2}
        direction='row'
        sx={{ float: 'right', margin: '15px 15px 20px 15px' }}
      >
        <Button
          variant='contained'
          onClick={() => {
            navigate(`/customer/customer_new`, {
              replace: true,
              state: {
                category: defaultCategory.id,
                name: '',
                store_man_name: '',
                store_man_num: '',
                regional_man_name: '',
                regional_man_number: '',
                deputy_div_man_name: '',
                deputy_div_man_number: '',
                div_man_name: '',
                div_man_number: '',
                technical_man_name: '',
                technical_man_number: '',
                region: defaultRegion.id,
                address: '',
                branchcode: '',
                store_tel: '',
                asset_man_comp: defaultAMC.id,
              },
            });
          }}
        >
          Add New
        </Button>
      </Stack>
    </Card>
  );
}

export default CustomerActionCard;
